export default {
	section_banner: {
		title: {
			one: 'Platform & ',
			two: 'Features',
		},
		paragraph: {
			one: 'Optimized for business management and tailored exclusively for',
			two: 'businesses, JPWorldPay provides powerful tools designed to',
			three: 'streamline operations.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	seller_access: {
		label: 'Optimized Your Business',
		title: {
			one: 'From Franchise',
			two: 'Management',
			three: 'To',
			four: 'Accurate Settlement',
		},
		paragraph:
			'Discover a platform optimized for your business. JPWorldPay is designed to support your unique operational needs, offering seamless payment solutions, smart financial tools, and secure transactions.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	question_sec: {
		label: 'As Simple As Possible',
		title: {
			one: 'Intuitive',
			two: '&',
			three: 'Simple',
		},
		paragraph: {
			one: 'As for business, it is as simple as possible. JPWorldPay streamlines every step of your financial workflow',
			two: 'from receiving payments to managing transactions, so you can focus on running & growing your business.',
			three:
				'With intuitive tools and a user-friendly interface, handling business finances has never been easier.',
		},
		cta_buttons: {
			one: 'Get Started',
		},
	},

	seller_access_rt: {
		label: 'Platform & Functions',
		title: {
			one: 'Ready To Use',
			two: 'Right',
			three: 'Away',
			four: 'Without Learning',
		},
		paragraph:
			'The platform and functions are designed to be simple, ensuring administrators can use them with ease. With a clean interface and intuitive navigation, JPWorldPay removes complexity, making daily operations straightforward and efficient.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
